<table class="ir-plugin-table">
  <tr>
    <td class="th-plugin-line--subheader" style="width: 33%">
      <span>
        <strong>{{ 'plugins.installationlubricant.brand' | translate }}</strong>
      </span>
    </td>
    <td class="th-plugin-line--subheader" style="width: 33%">
      <span>
        <strong>
          {{ 'plugins.installationlubricant.type' | translate }}
        </strong>
      </span>
    </td>
    <td class="th-plugin-line--subheader" style="width: 33%">
      <span>
        <strong>
          {{ 'plugins.installationlubricant.viscosity' | translate }}
        </strong>
      </span>
    </td>
  </tr>
  <tr *ngFor="let lubricant of lubricants">
    <td class="th-plugin-line--subheader" style="width: 33%">
      <p>
        <span>{{ lubricant.Brand }}</span>
      </p>
    </td>
    <td class="th-plugin-line--subheader" style="width: 33%">
      <p>
        <span>{{ lubricant.Type }}</span>
      </p>
    </td>
    <td class="th-plugin-line--subheader" style="width: 33%">
      <p>
        <span>{{ lubricant.Viscosity }}</span>
      </p>
    </td>
  </tr>
</table>
